<template>
  <div class="d-flex" style="height:100%">
    <ReminderMessage v-if="days_left >0" :me="me" />
    <ExpiredMessage v-else :me="me" />
  </div>
</template>

<script>

import ExpiredMessage from './ExpiredMessage'
import ReminderMessage from './ReminderMessage'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PaymentAlert',

  components: { ExpiredMessage, ReminderMessage },

  computed: {
    ...mapGetters('auth', ['me']),

    days_left() {
      let now = new Date()
      let expires = new Date(this.me.membership_last_valid_time)
      return Math.ceil((expires - now) / (24*3600*1000))
    },
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  }
}

</script>